import React from "react";
import { Box } from "rebass/styled-components";

export function Row(props: any) {
  return <Box variant="form">{props.children}</Box>;
}
